// extracted by mini-css-extract-plugin
export default {"autoComplete":"ES-z","error":"FS-z","disabled":"GS-z"};